import React, { useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useTranslation } from "react-i18next";
import EnterpriseGridCommon from "./Ag-Grid";

const SequenceDataView = ({
  rows,
}) => {
  const { t } = useTranslation();

  const [columnDefs] = useState([
    {
      headerName: t("sequenceTable.siNo"),
      field: "key",
      key: "key",
      minWidth: 80,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
        cellHeight: 30,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: "Spread",
      field: "spread2Column",
      key: "spread2Column",
      minWidth: 80,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("sequenceTable.pipeStart"),
      field: "pipeStart",
      key: "pipeStart",
      minWidth: 80,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      pivotComparator: (a, b) => b.localeCompare(a),
    
    },
    {
      headerName: t("sequenceTable.pipeId"),
      field: "pipeId",
      key: "pipeId",
      minWidth: 280,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("sequenceTable.pipeEnd"),
      field: "pipeEnd",
      key: "pipeEnd",
      minWidth: 80,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("sequenceTable.maxHilo"),
      field: "maxHilo",
      key: "maxHilo",
      minWidth: 170,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
    },
    {
      headerName: t("sequenceTable.tdc"),
      field: "tdc",
      key: "tdc",
      minWidth: 80,
      pivot: true,
      floatingFilter: true,
      filter: "agMultiColumnFilter",
      filterParams: {
        maxNumConditions: 1,
      },
      pivotComparator: (a, b) => b.localeCompare(a),
      headerTooltip: t("sequenceTable.tdcInfo"),
    },
  ]);

  const onRowClicked = (params) => {
    console.log("Row clicked", params);
    handleRowClick(params.data);
  };

  const processCellCallback = (params) => {
    if (params?.column?.colDef?.processCellForExport) {
      return params.column.colDef.processCellForExport(params);
    }
    return params.value;
  };

  return (
    <div
      className="ag-theme-alpine slog-grid-container"
      style={{ width: "100%" }}
    >
      <EnterpriseGridCommon
        rows={rows}
        columnDefs={columnDefs}
        onRowClicked={onRowClicked}
        exportFileName={"Sequence_Data"}
        processCellCallback={processCellCallback}
        heightValue={-295}
        slogData={true}
      />
    </div>
  );
};

export default SequenceDataView;
